<template>
  <div class="cam-list-container">
    <div class="page-header">
      <div class="title-section">
        <h2 class="page-title">我的监控</h2>
        <el-badge :value="onlineCount" type="success" class="online-badge">
          <span class="sub-title">实时监控设备</span>
        </el-badge>
      </div>
      <el-button type="primary" icon="el-icon-plus" round class="add-cam-btn">添加设备</el-button>
    </div>

    <el-row :gutter="24">
      <el-col
        v-for="item in dataList"
        :key="item.id"
        :xs="24"
        :sm="12"
        :md="8"
        :lg="6"
        style="margin-bottom: 24px;"
      >
        <el-card :body-style="{ padding: '0px' }" class="cam-card" shadow="never">
          <div class="cam-preview-wrapper" @click="handlePlay(item)">
            <div class="cam-preview-overlay">
              <i class="el-icon-video-play play-icon" />
            </div>
            <div class="cam-placeholder">
              <i class="el-icon-video-camera" />
            </div>

            <div class="status-indicator" :class="{ 'is-online': item.state }">
              <span class="dot" />
              {{ item.state ? '在线' : '离线' }}
            </div>
          </div>

          <div class="cam-content">
            <div class="cam-main-info">
              <h3 class="cam-name">{{ item.camName }}</h3>
              <p class="cam-id">设备 ID: {{ item.camId }}</p>
            </div>

            <div class="cam-footer">
              <span class="add-time">{{ item.addAt }}</span>
              <div class="action-group">
                <el-tooltip content="设备设置" placement="top">
                  <el-button icon="el-icon-setting" circle size="mini" class="setting-btn" />
                </el-tooltip>
                <el-button type="primary" size="mini" round @click="handlePlay(item)">实时画面</el-button>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-empty v-if="dataList.length === 0" description="未发现绑定的监控设备" :image-size="200" />
  </div>
</template>

<script>
import { getCamList } from '@/api/disk'

export default {
  name: 'CamList',
  data() {
    return {
      dataList: [],
      loading: false
    }
  },
  computed: {
    onlineCount() {
      return this.dataList.filter(i => i.state).length
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      getCamList().then(resp => {
        if (resp.code === 0) {
          this.dataList = resp.data
        }
      }).finally(() => {
        this.loading = false
      })
    },
    handlePlay(item) {
      if (!item.state) {
        this.$message.info('设备已离线，无法查看实时画面')
        return
      }
      this.$router.push({
        path: '/disk/cam/detail',
        query: { camId: item.camId }
      })
    }
  }
}
</script>

<style scoped>
.cam-list-container {
  padding: 10px;
}

/* 页面头部 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 30px;
}

.page-title {
  font-size: 24px;
  font-weight: 800;
  color: #1a1a1a;
  margin: 0;
}

.sub-title {
  font-size: 13px;
  color: #909399;
}

.add-cam-btn {
  font-weight: 600;
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.2);
}

/* 卡片整体 */
.cam-card {
  border: none;
  border-radius: 20px;
  overflow: hidden;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background: #fff;
  border: 1px solid #f0f0f0;
}

.cam-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.08);
}

/* 预览图区域 */
.cam-preview-wrapper {
  height: 180px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  background: linear-gradient(135deg, #2c3e50 0%, #000000 100%);
}

.cam-placeholder {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.cam-placeholder i {
  font-size: 50px;
  color: rgba(255, 255, 255, 0.2);
}

/* Hover 时的播放按钮 */
.cam-preview-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s;
  z-index: 2;
}

.cam-preview-wrapper:hover .cam-preview-overlay {
  opacity: 1;
}

.play-icon {
  font-size: 40px;
  color: #fff;
}

/* 状态标签 */
.status-indicator {
  position: absolute;
  top: 12px;
  left: 12px;
  padding: 4px 10px;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(4px);
  border-radius: 20px;
  color: #fff;
  font-size: 11px;
  display: flex;
  align-items: center;
  z-index: 3;
}

.dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  margin-right: 6px;
  background: #f56c6c; /* 默认离线红 */
}

.is-online .dot {
  background: #67c23a;
  box-shadow: 0 0 8px #67c23a;
  animation: breathe 2s infinite;
}

@keyframes breathe {
  0% { opacity: 1; }
  50% { opacity: 0.4; }
  100% { opacity: 1; }
}

/* 内容区域 */
.cam-content {
  padding: 16px;
}

.cam-name {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
  margin: 0 0 4px 0;
}

.cam-id {
  font-size: 12px;
  color: #909399;
  margin: 0;
}

.cam-footer {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.add-time {
  font-size: 12px;
  color: #c0c4cc;
}

.action-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.setting-btn {
  border: none;
  background: #f5f7fa;
  color: #606266;
}

.setting-btn:hover {
  background: #e4e7ed;
  color: #1a73e8;
}
</style>
